import PropTypes from 'prop-types';
import AddOrder from './AddOrder';
import EditOrder from './EditOrder';

const OrderView = ({
  clickedItemData = {
    isTimeLineNewOrder: false,
    isTimeLineEditOrder: false,
    orderId: undefined,
    propertyName: undefined,
    clickedDate: undefined, // Used only in New order click
    // Edit item props:
    costPerNight: NaN,
    dateFrom: undefined,
    dateTo: undefined,
    description: undefined,
    email: undefined,
    feeding: false,
    firstName: undefined,
    phone: undefined,
    propertyId: undefined,
    status: undefined,
    surname: undefined,
    totalCost: NaN
  },
  closeEditModalReloadData,
  allOrders,
  timeLineLoadedDataRange
  }) => {
  const isOrderEdit = clickedItemData.isTimeLineEditOrder;
  const isNewOrder = clickedItemData.isTimeLineNewOrder;

  if (isNewOrder) {
    return (
      <AddOrder
        clickedItemData={clickedItemData}
        closeEditModalReloadData={closeEditModalReloadData}
        allOrders={allOrders}
        timeLineLoadedDataRange={timeLineLoadedDataRange}
      />
    );
  }

  if (isOrderEdit) {
    return (
      <EditOrder
        clickedItemData={clickedItemData}
        closeEditModalReloadData={closeEditModalReloadData}
        allOrders={allOrders}
        timeLineLoadedDataRange={timeLineLoadedDataRange}
      />
    )
  }

};

OrderView.propTypes = {
  clickedItemData: PropTypes.shape({
    isTimeLineNewOrder: PropTypes.bool,
    isTimeLineEditOrder: PropTypes.bool,
    orderId: PropTypes.string,
    propertyName: PropTypes.string,
    clickedDate: PropTypes.instanceOf(Date),
    costPerNight: PropTypes.number,
    dateFrom: PropTypes.string,
    dateTo: PropTypes.string,
    description: PropTypes.string,
    email: PropTypes.string,
    feeding: PropTypes.bool,
    firstName: PropTypes.string,
    phone: PropTypes.string,
    propertyId: PropTypes.string,
    status: PropTypes.string,
    surname: PropTypes.string,
    totalCost: PropTypes.number
  }),
  closeEditModalReloadData: PropTypes.func.isRequired,
  allOrders: PropTypes.arrayOf(
    PropTypes.shape({})
  ),
  timeLineLoadedDataRange: PropTypes.shape({
    dateFrom: PropTypes.instanceOf(Date),
    dateTo: PropTypes.instanceOf(Date)
  }).isRequired
};

export default OrderView;
